import { render, staticRenderFns } from "./TipoDocumentoGrid.vue?vue&type=template&id=babcb16e&scoped=true&"
import script from "./TipoDocumentoGrid.vue?vue&type=script&lang=js&"
export * from "./TipoDocumentoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babcb16e",
  null
  
)

/* custom blocks */
import block0 from "./TipoDocumentoGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports